import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Card, Col, Container, Form, ListGroup, Modal, Row, Stack } from 'react-bootstrap';
import CardBasic from '../../../components/Card/card.basic';
import { AdminService } from '../../../services/admin.service';
import SideModal from '../../../components/SideModal/SideModal';
import { countries } from '../../../utilis/country.utiils';
import Select from 'react-select';
import { RiEdit2Line } from 'react-icons/ri';
import { FaTrashAlt } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function PricingIndex() {
  const [pricingData, setPricingData] = useState<any>([]);
  const [showAddPricingModal, setShowAddPricingModal] = useState<boolean>(false);
  const [updatePricing, setUpdatePricing] = useState<boolean>(false);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [price, setPrice] = useState('');

  const [showConfirmationModal, setShowConfirmationModal] = useState<any>(undefined)

  const getAllPricing = async () => {
    try {
      const res = await AdminService.getAllPricing();
      if (res.status === 200) {
        setPricingData(res.data || []);
      }
    } catch (error) {
      console.error('Error fetching pricing data:', error);
    }
  };

  useEffect(() => {
    getAllPricing();
  }, []);

  const handleAddPricing = async () => {
    if (!selectedCountry || !price) {
      alert('Please select a country and enter a price');
      return;
    }
    try {
      const newPricing = { country: selectedCountry.value, price: parseFloat(price) };
      const res = await AdminService.createPricing(newPricing);
      if (res.status === 200) {
        setShowAddPricingModal(false);
        setUpdatePricing(false);
        setPrice('');
        setSelectedCountry(null);
        getAllPricing();
      }
    } catch (error) {
      console.error('Error adding pricing:', error);
    }
  };

  const handleDeletePricing = async () => {
    await AdminService.deletePricing(showConfirmationModal).then((res) => {
      if (res.status === 200) {
        toast.success("Deleted")
        setShowConfirmationModal(undefined)
        getAllPricing();
      }
    }).catch(err => {
      toast.error(err.response.data)
    })
  }

  return (
    <>
      <Container>
        <Row className="mt-4">
          <Col>
            <Card className="shadow-sm border-0 rounded-3">
              <Card.Body>
                <Stack direction="horizontal" className="mb-3" gap={3}>
                  <Card.Title className="mb-0">Pricing</Card.Title>
                  <Button variant="primary" size="sm" className="ms-auto" onClick={() => setShowAddPricingModal(true)}>
                    Create Pricing
                  </Button>
                </Stack>

                <ListGroup variant="flush">
                  <ListGroup.Item className="d-flex justify-content-between align-items-center">
                    <strong>Default Price:</strong>
                    <span className="fw-bold">₹{pricingData?.default}</span>
                  </ListGroup.Item>

                  {pricingData?.pricing?.map((item: any, index: number) => (
                    <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                      <Stack direction="horizontal" gap={3}>
                        <span>{item.country}:</span>
                        <span className="fw-bold">₹{item.price}</span>
                      </Stack>
                      <div className="d-flex gap-2">
                        <ButtonGroup size="sm">
                          <Button
                            variant="outline-primary"
                            onClick={() => {
                              setUpdatePricing(true);
                              setSelectedCountry({ label: item.country, value: item.country });
                              setPrice(item.price);
                            }}
                          >
                            <RiEdit2Line /> Update
                          </Button>

                        </ButtonGroup>
                        <ButtonGroup size="sm">
                          <Button
                            variant="outline-danger"
                            onClick={() => setShowConfirmationModal(item.country)}
                          >
                            <FaTrashAlt /> Delete
                          </Button>

                        </ButtonGroup>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
        show={showConfirmationModal ? true : false}
        onHide={() => setShowConfirmationModal(undefined)}
        centered
        animation={true}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure want to delete this pricing?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowConfirmationModal(false)}>
            Close
          </Button>
          <Button variant="danger" onClick={handleDeletePricing}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <SideModal
        title="Add Pricing"
        show={showAddPricingModal}
        handleClose={() => setShowAddPricingModal(false)}
        body={
          <>
            <div style={{ height: '80vh' }}>
              <Form.Group className="mt-2">
                <Form.Label className="fw-bold text-secondary fs-12">Country</Form.Label>
                <Select
                  options={countries.map((country) => ({ label: country, value: country }))}
                  value={selectedCountry}
                  onChange={setSelectedCountry}
                />
              </Form.Group>
              <Form.Group className="mt-2">
                <Form.Label className="fw-bold text-secondary fs-12">Price</Form.Label>
                <Form.Control type="number" value={price} onChange={(e) => setPrice(e.target.value)} />
              </Form.Group>
            </div>
            <div>
              <Button className="w-100" onClick={handleAddPricing}>
                Add
              </Button>
            </div>
          </>
        }
      />
      <SideModal
        title="Update Pricing"
        show={updatePricing}
        handleClose={() => setUpdatePricing(false)}
        body={
          <>
            <div style={{ height: '80vh' }}>
              <Form.Group className="mt-2">
                <Form.Label className="fw-bold text-secondary fs-12">Country</Form.Label>
                <Select
                  options={countries.map((country) => ({ label: country, value: country }))}
                  value={selectedCountry}
                  onChange={setSelectedCountry}
                />
              </Form.Group>
              <Form.Group className="mt-2">
                <Form.Label className="fw-bold text-secondary fs-12">Price</Form.Label>
                <Form.Control type="number" value={price} onChange={(e) => setPrice(e.target.value)} />
              </Form.Group>
            </div>
            <div>
              <Button className="w-100" onClick={handleAddPricing}>
                Add
              </Button>
            </div>
          </>
        }
      />
    </>
  );
}